import { useContext } from 'react';
import { SequentialContext } from '../providers/SequentialStepsProvider';

export const useProductBookingSequential = () => {
  const ctx = useContext(SequentialContext);

  if (!ctx) {
    throw new Error('useProductBookingSequential must be used within a SequentialStepsProvider');
  }

  return ctx;
};
